"use strict";

var _slicedToArray = require("/codebuild/output/src042941679/src/CargoLink-Backoffice/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _regeneratorRuntime = require("/codebuild/output/src042941679/src/CargoLink-Backoffice/node_modules/@babel/runtime/regenerator/index.js");

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var _a;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useLiff = exports.LiffProvider = exports.LiffConsumer = exports.createLiffContext = void 0;

var jsx_runtime_1 = require("react/jsx-runtime");

var PropTypes = __importStar(require("prop-types"));

var react_1 = require("react");

var liff_stub_1 = require("./liff-stub");

var use_login_state_manager_1 = require("./use-login-state-manager");

var initLiff = function initLiff(_a) {
  var _b;

  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var stubEnabled, liffConfig, liff;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            stubEnabled = _a.stubEnabled, liffConfig = __rest(_a, ["stubEnabled"]);

            if (!stubEnabled) {
              _context.next = 5;
              break;
            }

            if (!(typeof stubEnabled === 'object')) {
              _context.next = 4;
              break;
            }

            return _context.abrupt("return", {
              liff: Object.assign(Object.assign({}, liff_stub_1.liffStub), stubEnabled),
              ready: true
            });

          case 4:
            return _context.abrupt("return", {
              liff: liff_stub_1.liffStub,
              ready: true
            });

          case 5:
            _context.prev = 5;

            if (!((_b = window.liff) !== null && _b !== void 0)) {
              _context.next = 10;
              break;
            }

            _context.t0 = _b;
            _context.next = 13;
            break;

          case 10:
            _context.next = 12;
            return Promise.resolve().then(function () {
              return __importStar(require('@line/liff'));
            });

          case 12:
            _context.t0 = _context.sent.default;

          case 13:
            liff = _context.t0;
            _context.next = 16;
            return liff.init(liffConfig);

          case 16:
            return _context.abrupt("return", {
              liff: liff,
              ready: true
            });

          case 19:
            _context.prev = 19;
            _context.t1 = _context["catch"](5);
            return _context.abrupt("return", {
              error: _context.t1,
              ready: false
            });

          case 22:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[5, 19]]);
  }));
};

var LiffProviderPropTypes = {
  children: PropTypes.element.isRequired,
  liffId: PropTypes.string.isRequired,
  stubEnabled: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
  withLoginOnExternalBrowser: PropTypes.bool
};

var createLiffProvider = function createLiffProvider(context) {
  var LiffProvider = function LiffProvider(_ref) {
    var children = _ref.children,
        liffId = _ref.liffId,
        _ref$stubEnabled = _ref.stubEnabled,
        stubEnabled = _ref$stubEnabled === void 0 ? false : _ref$stubEnabled;

    var _ref2 = (0, react_1.useState)(),
        _ref3 = _slicedToArray(_ref2, 2),
        error = _ref3[0],
        setError = _ref3[1];

    var _ref4 = (0, react_1.useState)(liff_stub_1.liffStub),
        _ref5 = _slicedToArray(_ref4, 2),
        originalLiff = _ref5[0],
        setLiff = _ref5[1];

    var _ref6 = (0, react_1.useState)(false),
        _ref7 = _slicedToArray(_ref6, 2),
        ready = _ref7[0],
        setReady = _ref7[1];

    var _ref8 = (0, use_login_state_manager_1.useLoginStateManager)(originalLiff),
        _ref9 = _slicedToArray(_ref8, 2),
        isLoggedIn = _ref9[0],
        liff = _ref9[1];

    (0, react_1.useEffect)(function () {
      (function () {
        return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
          var _yield$initLiff, error, liff, ready;

          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return initLiff({
                    liffId: liffId,
                    stubEnabled: stubEnabled
                  });

                case 2:
                  _yield$initLiff = _context2.sent;
                  error = _yield$initLiff.error;
                  liff = _yield$initLiff.liff;
                  ready = _yield$initLiff.ready;
                  setError(error);
                  setLiff(liff);
                  setReady(ready);

                case 9:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));
      })();
    }, [liffId, stubEnabled]);
    return (0, jsx_runtime_1.jsx)(context.Provider, Object.assign({
      value: {
        error: error,
        liff: liff,
        isLoggedIn: isLoggedIn,
        ready: ready
      }
    }, {
      children: children
    }), void 0);
  }; // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore


  LiffProvider.propTypes = LiffProviderPropTypes;
  return LiffProvider;
};

var createLiffContext = function createLiffContext() {
  var context = (0, react_1.createContext)({
    isLoggedIn: false,
    liff: liff_stub_1.liffStub,
    ready: false
  });
  context.displayName = 'LiffContext';
  return {
    LiffConsumer: context.Consumer,
    LiffProvider: createLiffProvider(context),
    useLiff: function useLiff() {
      return (0, react_1.useContext)(context);
    }
  };
};

exports.createLiffContext = createLiffContext;
_a = (0, exports.createLiffContext)(), exports.LiffConsumer = _a.LiffConsumer, exports.LiffProvider = _a.LiffProvider, exports.useLiff = _a.useLiff;